import { PropertyBidHistoryDTO } from "../DTO/propertyBidHistoryDTO";
import { AuctionBidHistory } from "./auctionBidHistory";

export class PropertyBidHistory{
    public propertyId!:number;
    public auctionBidHistories!:AuctionBidHistory[];

    public static mapToDTO(param:PropertyBidHistory) : PropertyBidHistoryDTO{
        
        let dto = new PropertyBidHistoryDTO();
        try
        {
            dto.propertyId = param.propertyId;
            dto.auctionBidHistories = param.auctionBidHistories.map(abh => AuctionBidHistory.mapToDTO(abh));
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }
    public static mapFromDTO(param:PropertyBidHistoryDTO) : PropertyBidHistory
    {
        
        let obj = new PropertyBidHistory();
        try
        {
            obj.propertyId = param.propertyId;
            obj.auctionBidHistories = param.auctionBidHistories.map(abh => AuctionBidHistory.mapFromDTO(abh));
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }
}